(function () {
  'use strict';
  if (window.GFFinderTrack) return;
  const allowed = new Set(['start', 'complete', 'product_click', 'no_match', 'invite_view', 'invite_click', 'invite_dismiss', 'entry_click']);
  window.GFFinderTrack = function (event, values = {}) {
    const q = new URLSearchParams(location.search);
    if (!allowed.has(event) || window.Shopify?.designMode || ['gf_qa', 'preview_theme_id', '_fd', 'pb'].some(k => q.has(k)) || /codex_qa|^qa$|internal/.test(q.get('utm_source') || '')) return;
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    const data = { finder_version: '2026-10-31-v1' };
    for (const key of ['source', 'interest', 'experience', 'budget', 'product_id', 'count', 'trigger']) {
      if (values[key] !== undefined && /^[a-zA-Z0-9_-]{1,40}$/.test(String(values[key]))) data[key] = String(values[key]);
    }
    try { if (typeof window.gtag === 'function') window.gtag('event', 'gf_finder_' + event, data); } catch (_) {}
    try { if (typeof window.clarity === 'function') { for (const key of ['source', 'interest', 'experience', 'budget', 'trigger']) if (data[key]) window.clarity('set', 'gf_finder_' + key, data[key]); window.clarity('event', 'gf_finder_' + event); } } catch (_) {}
  };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[data-finder-entry]');
    if (link) {
      try { const from = new URL(document.referrer); const handle = from.pathname.match(/\/products\/([a-z0-9-]+)$/)?.[1]; const to = new URL(link.href); if (from.origin === location.origin && handle && !to.searchParams.has('from')) { to.searchParams.set('from', handle); link.href = to.pathname + to.search; } } catch (_) {}
      window.GFFinderTrack('entry_click', { source: link.dataset.finderEntry });
    }
  });
})();
